import { render } from "./BanksEditing.vue?vue&type=template&id=1b83f0e0&ts=true"
import script from "./BanksEditing.vue?vue&type=script&lang=ts"
export * from "./BanksEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__